import { extendSchema } from 'govbr.frontend.policy/helpers';
import { defineMessages } from 'react-intl';

const messages = defineMessages({
  addCard: { id: 'Add card', defaultMessage: 'Add card' },
  align: { id: 'Align card', defaultMessage: 'Align card' },
  backgroundColor: {
    id: 'backgroundColor',
    defaultMessage: 'Background of cards',
  },
  buttonLabel: { id: 'Button label', defaultMessage: 'Button label' },
  buttonLink: { id: 'Button link', defaultMessage: 'Button link' },
  card: { id: 'Card', defaultMessage: 'Card' },
  cards: { id: 'Cards', defaultMessage: 'Cards' },
  cardsDescription: {
    id: 'cardsDescription',
    defaultMessage: 'Choose document or link content type to compose the area.',
  },
  cardSize: { id: 'Card size', defaultMessage: 'Card size' },
  cardsPerRow: { id: 'Cards per row', defaultMessage: 'Cards per row' },
  cardsPerRowDescription: {
    id: 'cardsPerRowDescription',
    defaultMessage:
      'Enter the number of cards that must be displayed per line.',
  },
  center: { id: 'Center', defaultMessage: 'Center' },
  content: { id: 'Content', defaultMessage: 'Content' },
  gray: { id: 'gray', defaultMessage: 'Gray' },
  subtitle: { id: 'Subtitle', defaultMessage: 'Subtitle' },
  headerAndFooter: { id: 'Header / Footer', defaultMessage: 'Header / Footer' },
  hideDescription: {
    id: 'Hide card descriptions',
    defaultMessage: 'Hide card descriptions',
  },
  hideIcons: {
    id: 'Hide card icons',
    defaultMessage: 'Hide card icons',
  },
  large: { id: 'Large', defaultMessage: 'Large' },
  left: { id: 'Left', defaultMessage: 'Left' },
  medium: { id: 'Medium', defaultMessage: 'Medium' },
  right: { id: 'Right', defaultMessage: 'Right' },
  small: { id: 'Small', defaultMessage: 'Small' },
  source: { id: 'Source', defaultMessage: 'Source' },
  title: { id: 'Title', defaultMessage: 'Title' },
  white: { id: 'white', defaultMessage: 'White' },
});

export const cardSchema = ({ intl }) => {
  return {
    title: intl.formatMessage(messages.card),
    addMessage: intl.formatMessage(messages.addCard),
    fieldsets: [
      {
        id: 'default',
        title: intl.formatMessage(messages.content),
        fields: ['source'],
      },
    ],
    properties: {
      source: {
        title: intl.formatMessage(messages.source),
        widget: 'object_browser',
        mode: 'link',
        selectedItemAttrs: ['UID'],
        selectableTypes: ['Link', 'Document', 'Area'],
        allowExternals: false,
      },
    },
    required: [],
  };
};

export const baseCardsSchema = ({ intl }) => {
  return {
    fieldsets: [
      {
        id: 'default',
        title: intl.formatMessage(messages.cards),
        fields: [
          'cardSize',
          'columns',
          'align',
          'backgroundColor',
          'hideDescription',
          'hideIcons',
        ],
      },
      {
        id: 'headerAndFooter',
        title: intl.formatMessage(messages.headerAndFooter),
        fields: ['title', 'subtitle', 'buttonLabel', 'buttonLink'],
      },
    ],
    properties: {
      cardSize: {
        title: intl.formatMessage(messages.cardSize),
        required: true,
        noValueOption: false,
        default: 'md',
        type: 'string',
        factory: 'Choice',
        choices: [
          ['sm', intl.formatMessage(messages.small)],
          ['md', intl.formatMessage(messages.medium)],
          ['lg', intl.formatMessage(messages.large)],
        ],
      },
      align: {
        title: intl.formatMessage(messages.align),
        required: true,
        noValueOption: false,
        default: 'center',
        type: 'string',
        factory: 'Choice',
        choices: [
          ['start', intl.formatMessage(messages.left)],
          ['center', intl.formatMessage(messages.center)],
          ['end', intl.formatMessage(messages.right)],
        ],
      },
      backgroundColor: {
        title: intl.formatMessage(messages.backgroundColor),
        required: true,
        noValueOption: false,
        default: 'gray',
        type: 'string',
        factory: 'Choice',
        choices: [
          ['gray', intl.formatMessage(messages.gray)],
          ['white', intl.formatMessage(messages.white)],
        ],
      },
      columns: {
        title: intl.formatMessage(messages.cardsPerRow),
        description: intl.formatMessage(messages.cardsPerRowDescription),
        required: true,
        noValueOption: false,
        default: '4',
        type: 'string',
        factory: 'Choice',
        choices: [
          ['1', '1'],
          ['2', '2'],
          ['3', '3'],
          ['4', '4'],
          ['5', '5'],
        ],
      },
      hideDescription: {
        title: intl.formatMessage(messages.hideDescription),
        required: false,
        default: false,
        type: 'boolean',
      },
      hideIcons: {
        title: intl.formatMessage(messages.hideIcons),
        required: false,
        default: false,
        type: 'boolean',
      },
      title: { title: intl.formatMessage(messages.title) },
      subtitle: {
        title: intl.formatMessage(messages.subtitle),
      },
      buttonLink: {
        title: intl.formatMessage(messages.buttonLink),
        widget: 'object_browser',
        mode: 'link',
        // return :'single',
        selectedItemAttrs: ['Title', 'Description'],
        allowExternals: true,
      },
      buttonLabel: {
        title: intl.formatMessage(messages.buttonLabel),
      },
    },
    required: ['cards', 'cardSize', 'columns', 'align', 'backgroundColor'],
  };
};

export const cardsSchema = ({ intl }) => {
  const fields = ['cards'];
  const properties = {
    cards: {
      widget: 'object_list',
      title: intl.formatMessage(messages.cards),
      description: intl.formatMessage(messages.cardsDescription),
      schema: cardSchema,
    },
  };
  return extendSchema(baseCardsSchema, { intl }, fields, properties);
};
